/**
 * Created by cbaumgartner on 21.04.15.
 */
$(document).ready(function(){
	$(".offcanvas_element:nth-child(3n+3)").css('margin-right', '0');
	$('.offcanvas-trigger').click(function(e) {
		e.preventDefault();
		$('.offcanvas').slideToggle( "fast", function(){
			$('.offcanvas-trigger').toggleClass('offcanvas_isOpen');
		});
	});
});